import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import { BaseEntityAssociationController } from "../ts/rlAdmin.controllers";
import { AdminService } from "../services/admin-service";
import { NotifyService } from "../services/notify-service";
import { SearchService } from "../services/search-service";
import { EntityService } from "../services/entity-service";
import { AclService } from "../services/acl-service";
import { EventService } from "../services/event-service";

export function RLProjects() {
    var directive: ng.IDirective = {
        restrict: "AE",
        template: require("/assets/app/templates/projects.html"),
        controller: RLProjectsController,
        controllerAs: "pVM",
        bindToController: true,
        scope: {
            entityID: "=entityId",
            templateID: "=templateId",
            locked: "=",
            selectedEntity: "="
        }
    };

    return directive;
}

class RLProjectsController extends BaseEntityAssociationController {
    static $inject = ["$scope", "$q", "$window", "$filter", "$interval", "adminService", "notifyService", "searchService", "entityService", "aclService", "eventService"];

    entityID: string;
    templateID: number;
    locked: boolean;

    canEdit: boolean;
    initialized: boolean;
    projects: Models.IEntitySearchDoc[];
    filterByTemplateIds: number[];

    //Paging
    searchPage: number;
    searchPageSize: number;
    searchPageCount: number;
    searchNumFound: number;
    //--

    //Add Association Modal
    searchModal: boolean;
    parentCharTypeID: number;
    childChartypeID: number;
    parentTemplateID: number;
    showColumns: string[];
    canCreate: string;
    allowMultiple: boolean;
    showAdvance: boolean;
    selectedRecIdTitlePairs: Models.IKeyValuePair<number, string>[];
    //--

    //Eyeball Preview
    selectedEntity: any;
    selectedEntityID: string;
    //--

    constructor(
        public $scope: ng.IScope,
        public $q: ng.IQService,
        private $window: ng.IWindowService,
        private $filter: ng.IFilterService,
        public $interval: ng.IIntervalService,
        public adminService: AdminService,
        public notifyService: NotifyService,
        private searchService: SearchService,
        private entityService: EntityService,
        private aclService: AclService,
        private eventService: EventService) {

        super($scope, notifyService, adminService, $interval, $q, entityService, eventService);

        this.initialized = false;
        this.projects = [];
        this.filterByTemplateIds = [];

        this.searchPage = 1;
        this.searchPageSize = 10;
        this.searchPageCount = 1;
        this.searchNumFound = 0;

        this.searchModal = false;
        this.parentTemplateID = 0;
        this.childChartypeID = Consts.CharTypeIDs.project;
        this.showColumns = [];
        this.canCreate = "false";
        this.allowMultiple = false;
        this.showAdvance = true;
        this.selectedRecIdTitlePairs = [];

        $scope.$watch(() => this.templateID, (newValue, oldValue) => {
            if (this.entityID != null && this.templateID != null) {
                this.parentCharTypeID = Utils.IdBuilder.splitEntityID(this.entityID).charTypeID;
                this.parentTemplateID = this.templateID;

                entityService.getAssociatedTemplatesForTemplate(this.parentCharTypeID, this.templateID, this.childChartypeID)
                    .then((result) => {
                        this.filterByTemplateIds = [];
                        var templates = result.filter(ct => Utils.AclUtil.hasReadAccess(this.aclService.acls, ct.acl));

                        _.forEach(templates, t => {
                            this.filterByTemplateIds.push(t.templateID);
                        });
                    })
                    .finally(() => {
                        this.LoadPermissions();
                        this.RefreshProjects();
                    });
            }
        });
    }

    LoadPermissions() {
        this.aclService.loadActivityAcls()
            .then((acls) => {
                //Add more to the switch statement when this directive is used on other char types
                switch (Utils.IdBuilder.splitEntityID(this.entityID).charTypeID) {
                    case Consts.CharTypeIDs.invoice:
                        this.canEdit = Utils.AclUtil.hasWriteAccess(acls, Consts.Acl.Activities._Site._Mod7.Projects);
                        break;
                }
            });
    }

    RefreshProjects(): ng.IPromise<any> {
        this.notifyService.startProgress();

        var searchState: Models.IAdvancedSearchModel = {
            charTypeID: Consts.CharTypeIDs.project,
            searchGroups: [],
            keywords: "",
            page: this.searchPage || 1,
            rowCount: 10,
            templateGroupIDs: [1, 2],
            template: "",
            status: "",
            sortDir: 1,
            sortField: "",
            relatedEntityID: this.entityID,
            filterByTemplateIds: this.filterByTemplateIds
        };

        return this.searchService.advancedSearch(searchState)
            .then((res) => {
                if (res.documents.length > 0) {
                    this.searchNumFound = res.documents.length;
                    this.searchPageCount = Math.ceil(this.searchNumFound / this.searchPageSize) || 1;
                }
                else {
                    this.searchNumFound = 0;
                    this.searchPageCount = 1;
                }

                this.projects = res.documents;

                this.initialized = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    SearchProjects() {
        this.searchModal = true;
        this.allowMultiple = true;
        this.showAdvance = true;
        this.selectedRecIdTitlePairs = [];
    }

    AddProjects() {
        var projectIDs: string[] = [];

        var divID = Utils.IdBuilder.splitEntityID(this.entityID).divID;
        var charTypeID = Consts.CharTypeIDs.project;

        if (this.selectedRecIdTitlePairs.length > 0) {
            this.selectedRecIdTitlePairs.forEach((item) => {
                projectIDs.push(Utils.IdBuilder.buildEntityID(divID, charTypeID, item.key));
            });
        }

        if (projectIDs.length > 0) {
            // start progress bar
            this.notifyService.startProgress();
            this.progressStatus = "";
            // make rest call
            this.entityService.associateEntity(this.entityID, projectIDs, 0)
                .then((result) => {
                    if (_.isEmpty(result.jobTitle)) {
                        this.notifyService.notifyError("There was an error associating these records.\n Please make sure you are not attempting to create a circular reference.");
                        this.selectedRecIdTitlePairs = [];
                        this.searchModal = false;
                    }
                    else {
                        var jobID = result.jobID;
                        this.jobTitle = result.jobTitle;

                        this.ShowProgress(jobID, () => {
                            this.RefreshProjects();
                        });
                    }
                }, (event) => {
                    // error handler
                    this.notifyService.notifyError("There was an error associating these records.\n Please make sure you are not attempting to create a circular reference.");
                })
                .then(() => {
                    // close modal
                    this.searchModal = false;
                })
                .finally(() => {
                    // end progress bar
                    this.notifyService.endProgress();
                });
        } else {
            // notify no selected projects
            this.notifyService.notifyError("No Projects were selected");
        }
    }

    RemoveProject(entityID: string) {
        if (this.$window.confirm("Are you sure?")) {
            this.notifyService.startProgress();

            var parentEntity = this.entityID;
            var childEntity = entityID;

            this.entityService.deleteAssociation(parentEntity, childEntity)
                .then(() => {
                    this.RefreshProjects()
                        .then(() => {
                            this.notifyService.notifySuccess("Association removed");
                        });

                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    //Eyeball Preview
    ViewEntity(entityID: string) {
        if (!this.selectedEntity || this.selectedEntity.record.id != entityID) {
            this.selectedEntityID = entityID;
            this.entityService.getEntity(entityID)
                .then((res) => {
                    this.selectedEntity = res;
                });
        } else {
            this.selectedEntityID = undefined;
            this.selectedEntity = undefined;
        }
    }
    //--
}
